export default __webpack_public_path__ + "static/media/activity_signup.24003aea.svg";